"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

export default function NavBar() {
  const [scrollY, setScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      scrollY > 40 ? "bg-white shadow-md py-1" : "bg-white/90 py-1.5"
    }`}>
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <Link href="/" className="flex items-center cursor-pointer">
          <img src="/logo.png" alt="Contract Lucidity" className="h-12 md:h-14" />
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <Link href="/features" className="text-sm text-gray-600 hover:text-[#1B3A6B] transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>Features</Link>
          <Link href="/how-it-works" className="text-sm text-gray-600 hover:text-[#1B3A6B] transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>How It Works</Link>
          <Link href="/law-firms" className="text-sm text-gray-600 hover:text-[#1B3A6B] transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>Law Firms</Link>
          <Link href="/in-house" className="text-sm text-gray-600 hover:text-[#1B3A6B] transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>In-House</Link>
          <Link href="/security" className="text-sm text-gray-600 hover:text-[#1B3A6B] transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>Security</Link>
          <Link href="/why-contract-lucidity" className="text-sm text-gray-600 hover:text-[#1B3A6B] transition-colors" style={{ fontFamily: "system-ui, sans-serif" }}>Why Us</Link>
          <a href="https://lucidvault.contractlucidity.com" target="_blank" rel="noopener noreferrer" className="text-sm text-[#C8A84B] hover:text-[#b8993f] transition-colors font-semibold" style={{ fontFamily: "system-ui, sans-serif" }}>Lucid Vault</a>
          <Link
            href="/login"
            className="px-6 py-2.5 text-sm font-semibold bg-[#1B3A6B] text-white rounded hover:bg-[#2E5EA0] transition-colors"
            style={{ fontFamily: "system-ui, sans-serif" }}
          >
            Sign In
          </Link>
        </div>
        {/* Mobile hamburger */}
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2" aria-label="Toggle menu">
          <svg className="w-6 h-6 text-[#1B3A6B]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {mobileMenuOpen
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>
      </div>
      {/* Mobile menu dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg" style={{ fontFamily: "system-ui, sans-serif" }}>
          <div className="flex flex-col px-6 py-4 gap-3">
            <Link href="/features" onClick={() => setMobileMenuOpen(false)} className="text-sm text-gray-600 hover:text-[#1B3A6B] py-2 border-b border-gray-50">Features</Link>
            <Link href="/how-it-works" onClick={() => setMobileMenuOpen(false)} className="text-sm text-gray-600 hover:text-[#1B3A6B] py-2 border-b border-gray-50">How It Works</Link>
            <Link href="/law-firms" onClick={() => setMobileMenuOpen(false)} className="text-sm text-gray-600 hover:text-[#1B3A6B] py-2 border-b border-gray-50">Law Firms</Link>
            <Link href="/in-house" onClick={() => setMobileMenuOpen(false)} className="text-sm text-gray-600 hover:text-[#1B3A6B] py-2 border-b border-gray-50">In-House</Link>
            <Link href="/security" onClick={() => setMobileMenuOpen(false)} className="text-sm text-gray-600 hover:text-[#1B3A6B] py-2 border-b border-gray-50">Security</Link>
            <Link href="/why-contract-lucidity" onClick={() => setMobileMenuOpen(false)} className="text-sm text-gray-600 hover:text-[#1B3A6B] py-2 border-b border-gray-50">Why Us</Link>
            <a href="https://lucidvault.contractlucidity.com" target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)} className="text-sm text-[#C8A84B] font-semibold hover:text-[#b8993f] py-2 border-b border-gray-50">Lucid Vault</a>
            <Link href="/login" onClick={() => setMobileMenuOpen(false)} className="text-sm font-semibold text-white bg-[#1B3A6B] rounded px-4 py-2.5 text-center mt-2">Sign In</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
